import { Amplify } from "aws-amplify"
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito"
import { CookieStorage } from "aws-amplify/utils"

let amplifyConfigured = false

export function initializeAmplify() {
	if (!amplifyConfigured) {
		const userPoolId = import.meta.env.VITE_USER_POOL_ID;
		const appClientId = import.meta.env.VITE_APP_CLIENT_ID;

		if (!userPoolId || !appClientId) {
			console.error('Missing Cognito configuration. Please set VITE_USER_POOL_ID and VITE_APP_CLIENT_ID in .env file');
			return;
		}

		Amplify.configure({
			Auth: {
				Cognito: {
					userPoolId,
					userPoolClientId: appClientId,
				},
			},
		})

		if (process.env.NODE_ENV === "production") {
			cognitoUserPoolsTokenProvider.setKeyValueStorage(
				new CookieStorage({
					path: "/",
					expires: 365,
					sameSite: "none",
					secure: true,
				}),
			)
		}

		amplifyConfigured = true
	}
}
